export const Marquee = ({ items, dark = true, className = "" }) => {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-800 uppercase tracking-tight text-2xl sm:text-4xl font-extrabold px-6 sm:px-10 whitespace-nowrap">
            {item}
          </span>
          <span className={`h-2 w-2 sm:h-3 sm:w-3 ${dark ? "bg-accent" : "bg-ink"}`} />
        </span>
      ))}
    </div>
  );

  return (
    <div
      className={`overflow-hidden border-y py-5 sm:py-7 select-none ${
        dark ? "bg-ink text-paper border-ink" : "bg-paper text-ink border-ink/15"
      } ${className}`}
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};
